// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"02afbc5e","703":"bae61f32","787":"0be52526"}[chunkId] + ".chunk.js";
};